import React from 'react';

export const AccountMenuItem = (
  props: React.HTMLProps<HTMLDivElement> & { isActive?: boolean },
) => {
  return (
    <div
      {...props}
      className={`
        account-menu-item px-4 py-3.5 rounded-2xl transition-all -ml-4 relative z-20
        hover:bg-[#FFFFFF33]
        ${props.className}
        [&_p]:text-neutral-whiteboard [&_p]:flex [&_p]:justify-start [&_p]:items-center
        ${props.isActive ? 'bg-[#FFFFFF33]' : ''}
      `}
    >
      {props.children && props.children}
    </div>
  );
};

export const AccountMenuItemSpan = (
  props: React.HTMLProps<HTMLSpanElement>,
) => {
  return (
    <span {...props} className="text-md leading-4 font-bold">
      {props.children && props.children}
    </span>
  );
};
